import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const loginUser = createAsyncThunk('loginUser', async (object, { rejectWithValue }) => {
  const response = await request('/api/v1/tenant-user-login', { method: 'POST', body: object });

  if (response?.success) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});